// dependencies
import json2csv from "json2csv";
import { GenerateProcess } from "redux-process";

// ui
import ui from "./ui";

// actions
import { changePageUI as updateUI } from "Actions/ui";

// selectors
import { getUI } from "Selectors/ui";
import { getLimit, getOffest } from "./selectors";

/**
 * Fetch (or refetch) the data
 */
export const fetchPageData = () => async (dispatch, getState) => {
	// request
	const state = getState();
	const skip = getOffest(state);
	const limit = getLimit(state);

	// request
	const request = await dispatch(GenerateProcess("GetRecentlyDeactivatedUsers", { limit, skip }));

	const data = request.response.toJS();
	const csv = json2csv.parse(data, {
		fields: ["id", "name", "jobTitle", "role", "companyID", "companyName", "deactivationDate"],
	});

	let currentUI = getUI(getState());
	currentUI = currentUI.set("data", request.response);
	currentUI = currentUI.set("csvData", csv);

	dispatch(updateUI([], currentUI));
};

/**
 * Initialize page.
 */
export const init = () => (dispatch) => {
	// set the initial UI
	const initialUI = ui;
	dispatch(updateUI([], initialUI));

	// fetch page data
	dispatch(fetchPageData());
};
